export enum Constants {
    STORAGE_PREFIX = 'ccp',
    RETURN_URL_KEY = 'ccp.returnUrl',
    USER_INFO_KEY = 'userInfo',
    MARKET_TIMEZONE = 'marketTimezone'
}
